import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';
import { capitalDesignTokens } from '../../capital_design_tokens';

export const MuiPickersLayout: ThemeOptions['components']['MuiPickersLayout'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiPickersLayout-actionBar': {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
      },
      '& .MuiDateRangePickerToolbar-container': {
        '& .MuiTypography-root': {
          fontSize: capitalDesignTokens.foundations.typography.fontSize.h3
        },
        '& .MuiButton-root': {
          minHeight: 1
        }
      },
      '& .MuiList-root': {
        border: 'none',
        boxShadow: 'none'
      }
    })
  }
};
